import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getProducts = async () => (await axios.get(`${API}/products`)).data;
export const submitContact = async (payload) => (await axios.post(`${API}/contact`, payload)).data;
export const subscribeEmail = async (email) => (await axios.post(`${API}/subscribe`, { email })).data;
export const getSubscriberCount = async () => (await axios.get(`${API}/subscribers/count`)).data;
export const notifyMerch = async (email) => (await axios.post(`${API}/merch/notify`, { email })).data;
export const restockNotify = async (productId, email) =>
  (await axios.post(`${API}/restock/notify`, { product_id: productId, email })).data;
export const createEmailOrder = async (payload) => (await axios.post(`${API}/order`, payload)).data;
export const createCheckout = async (payload) => (await axios.post(`${API}/checkout/session`, payload)).data;
export const getQuote = async (payload) => (await axios.post(`${API}/checkout/quote`, payload)).data;
export const getCheckoutStatus = async (sessionId) =>
  (await axios.get(`${API}/checkout/status/${sessionId}`)).data;

export const adminStats = async (token) =>
  (await axios.get(`${API}/admin/stats`, { params: { token } })).data;
export const adminLogin = async (password) =>
  (await axios.post(`${API}/admin/login`, { password })).data;
export const adminOrders = async (token) =>
  (await axios.get(`${API}/admin/orders`, { params: { token } })).data;
export const adminContacts = async (token) =>
  (await axios.get(`${API}/admin/contacts`, { params: { token } })).data;
export const updateOrderStatus = async (token, orderId, status) =>
  (await axios.patch(`${API}/admin/orders/${orderId}/status`, { status }, { params: { token } })).data;
export const announceLaunch = async (token) =>
  (await axios.post(`${API}/admin/announce-launch`, {}, { params: { token } })).data;
export const adminInventory = async (token) =>
  (await axios.get(`${API}/admin/inventory`, { params: { token } })).data;
export const updateStock = async (token, productId, stockStatus) =>
  (await axios.patch(`${API}/admin/products/${productId}/stock`, { stock_status: stockStatus }, { params: { token } })).data;
export const updateQuantity = async (token, productId, quantity) =>
  (await axios.patch(`${API}/admin/products/${productId}/quantity`, { quantity }, { params: { token } })).data;
export const exportUrl = (token, kind) => `${API}/admin/export/${kind}?token=${encodeURIComponent(token)}`;
export const ownerInventory = async (token) =>
  (await axios.get(`${API}/admin/owner-inventory`, { params: { token } })).data;
export const purgeTestData = async (token) =>
  (await axios.post(`${API}/admin/purge-test-data`, { confirm: "DELETE" }, { params: { token } })).data;

export const SOCIALS = {
  tiktok: "https://www.tiktok.com/@sweet.tooth.bandit",
  facebook: "https://www.facebook.com/share/1DkVcGDB2s/",
};

export const SHOP_CONTACT_EMAIL = "sweettoothbanditshop@outlook.com";

export const LOGO_URL = "/logo.png";
export const LAUNCH_DATE = "2026-07-16T23:59:00";
// Shop opens for bouquet orders: Nov 1, 2026 12:00 AM Central Time
export const SHOP_OPEN_AT = "2026-11-01T00:00:00-05:00";

const _S = (h) => `https://static.prod-images.emergentagent.com/jobs/761fbb50-b680-4db2-8057-6dae0097db6a/images/${h}.png`;
export const BOUQUET_GALLERY = [
  { src: _S("e7119ee548ec8638556d8bfd24328fd281a4c0e13904a54badd17d129a4c32ca"), title: "Classic Candy Bouquet", tag: "Lollipops & chews" },
  { src: _S("9c1c13d556a0b03a85a5ca07d2b718f3b3b3400049890289c059e5ac0cb8c70f"), title: "Gift-Box Bouquet", tag: "Brand-name favorites" },
  { src: _S("9ca4ca7fd752d3eda5af3676dd8fc1c6e64b737b70e8df7566b8be54abbff694"), title: "Birthday Bouquet", tag: "Party ready" },
  { src: _S("1d98e48616470071f291f42ed7b5066e3a3b656cd5f5d47a565ca9746e709c3c"), title: "Graduation Bouquet", tag: "Congrats, grad!" },
  { src: _S("86f139e9094974ac423e9e67b3d83a91763a723615df534e838e04979dd210d7"), title: "Sweetheart Bouquet", tag: "For your valentine" },
  { src: _S("fac22a64c5ff64a94a39c84a4d9c003ed8aac0874db93025bd64774c2efe1fc5"), title: "Kids' Rainbow Bouquet", tag: "Gummies & ring pops" },
];
export const MERCH_URL =
  "https://customer-assets.emergentagent.com/job_761fbb50-b680-4db2-8057-6dae0097db6a/artifacts/eskdlf02_19182.png";
export const CANDY_TABLE_URL =
  "https://customer-assets.emergentagent.com/job_761fbb50-b680-4db2-8057-6dae0097db6a/artifacts/21br7jas_19176.webp";
export const HERO_FLATLAY_URL =
  "https://static.prod-images.emergentagent.com/jobs/761fbb50-b680-4db2-8057-6dae0097db6a/images/5d4cda16d92d27b5e0181b0c76b0a4ce0fb9445255863f3f6c412716dab95c98.png";
